<template>
<div class="row">
  <div class="col-md-4" style="    display: flex;
    justify-content: center;">
    <div class="profile-image-upload-wrapper">
      <div class="profile-image-display">
        <img v-if="imageType == 'image'" :src="getProxyConvertedURL(postData.profile_image)" style="height:100%;width:100%">
        <svg v-else-if="imageType == null" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16" style="height: 100% !important;width: 100% !important;color: #4e4e4e;">
            <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
        </svg>
        <canvas v-else-if="imageType == 'canvas'" ref="preferenceUploadCanvas" style="border-radius:5px;" id="canvas"></canvas>
        <!-- <img id="image_tag" style="width:128px;height:100%;"/> -->
      </div>
      <div class="upload-profile-image-button" :style="imageType != null?'display: flex;width: 185px;':''">
        <div style="position:relative" class="btn-wrapper profile-image">
          <button v-if="imageType == null" class="btn btn-outline-primary profile-image-change">{{$t('Upload')}}</button>
          <button v-else class="btn btn-outline-primary profile-image-change">{{$t('Change')}}</button>
          <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
          <input type="file"
            class="comm-input-field-style"
            id="img-input"
            ref="uploadFile"
            @change="uploadProfileImage($event)"
            accept="image/png, image/jpeg"></div>
        </div>
        <div v-if="imageType != null" style="position:relative;margin-inline-start: 10px;" class="btn-wrapper">
          <button class="btn btn-outline-secondary" @click="removeProfileImage()">{{$t('Remove')}}</button>
        </div>
        <!-- <div class="btn-wrapper"><button @click="saveBasicInfoField(userInfo)" class="btn btn-outline-primary" style="width:96%" data-v-198e7d7f="">Upload an image</button></div> -->
      </div>
    </div>
  </div>
  <div class="col-md-8">
     <table class="table users-basic-info-table" style="background: transparent">
                    <thead style="color: #eee">
                      <tr>
                        <th scope="col" style="width: 30%"></th>
                        <th scope="col" style="width: 70%"></th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                          <td class="key-div">{{$t('Username')}}</td>
                          <td class="value-div d-inline-flex float-left m-0 w-100">
                            <div class="w-100">
                              <div class="d-inline-flex">
                                <span v-show="!isEditting('name')">{{userInfo.username}}</span>
                                <!-- <edit-icon @click.native="editBasicInfoField('name')" v-show="!isEditting('name')" class="editIcon"></edit-icon> -->
                              </div>
                              <!-- <input minlength="3" type="text" v-model="postData.username" v-show="isEditting('name')" class="bg-transparent border rounded text-light w-100" required/> -->
                            </div>
                            <!-- <div v-show="isEditting('name')">
                              <div class="d-flex">
                                <save-icon @click.native="saveBasicInfoField('username')"></save-icon>
                                <cancel-icon @click.native="cancelBasicInfoField()"></cancel-icon>
                              </div>
                            </div> -->
                          </td>
                        </tr>
                        <tr>
                          <td class="key-div">{{$t('Current Password')}}</td>
                          <td class="value-div" style="width: 100% !important;display:flex;padding-inline-start:2px !important">
                            <div class="w-100" style="position: relative;display: inline-flex;width: 100%;align-items: center;">
                              <div class="d-inline-flex">
                                <span v-show="!isEditting('password')">******</span>
                                <edit-icon @click.native="editBasicInfoField('password')" v-show="!isEditting('password')" class="editIcon"></edit-icon>
                              </div>
                              <input :type="currentPasswordFieldType" id="oldPassword" v-show="isEditting('password')" 
                              class="bg-transparent border rounded text-light w-100 pl-2 comm-input-field-style" placeholder="Enter current password" v-model="postData.old_password" style="padding-inline-end:5%">
                              <svg width="1em" height="1em"  @click="switchVisibilityCurrentPassword" type="password"  v-show="isEditting('password')" viewBox="0 0 16 16" class="bi bi-eye ml-1" style="position: absolute;inset-inline-end :3%;" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"/>
                                <path fill-rule="evenodd" d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                              </svg>
                            </div>
                            <div v-if="isEditting('password')" style="width:101px"></div>
                          </td>
                        </tr>
                        <tr v-show="isEditting('password')">
                          <td class="key-div">{{$t('New Password')}}</td>
                          <td class="value-div" style="width: 100% !important">
                            <div class="w-100" style="position: relative;display: inline-flex;width: 100%;align-items: center;">
                              <div class="w-100" style="position: relative;display: inline-flex;width: 100%;align-items: center;" >
                              <input :type="passwordFieldType" @input="validPasswordCheck" id="password" 
                              class="bg-transparent border rounded text-light w-100 pl-2 comm-input-field-style" placeholder="Enter new password" v-model="postData.password" style="padding-inline-end:5%">
                              <svg width="1em" height="1em"  @click="switchVisibilityNewPassword" type="password" viewBox="0 0 16 16" class="bi bi-eye ml-1" style="position: absolute;inset-inline-end :3%;" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"/>
                                <path fill-rule="evenodd" d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                              </svg>
                              </div>
                              <div v-if="isEditting('password')" style="width:86px"></div>
                            </div>
                            <span v-show='!validPassword' class="pl-1 pt-1 validationmessage">
                              <template v-if="!isPasswordEnforced()">
                                {{$t('Empty Password')}}
                              </template>
                              <template v-else>
                                Password Must be 8 characters with 1Uppercase, 1Lowercase, 1Numeric & 1Special char
                              </template>
                            </span>
                          </td>
                        </tr>
                        <tr  v-show="isEditting('password')">
                          <td class="key-div" >{{$t('Verify Password')}}</td>
                          <td class="value-div" style="width: 100% !important">
                            <div style="display: inline-flex;width:100%">
                              <div style="position: relative;width: 100%;display: inline-flex;align-items: center;">
                                <input :type="verifypasswordFieldType" @input="passwordVerificationCheck" id="verifyPassword"
                                class="bg-transparent border rounded text-light pl-2 comm-input-field-style w-100"  placeholder="Enter new password again" v-model="verifiedPassword" style="width: 76%;padding-inline-end: 5%;">
                                <svg width="1em" height="1em"  @click="switchVisibilityVerifyPassword" type="password" viewBox="0 0 16 16" class="bi bi-eye ml-1" style="position: absolute;inset-inline-end :28%;" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"/>
                                  <path fill-rule="evenodd" d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                                </svg>
                                <div class="d-flex" style="margin-inline-start: 10px;">
                                <save-icon @click.native="saveBasicInfoField('password')"></save-icon>
                                <cancel-icon @click.native="cancelBasicInfoField()"></cancel-icon>
                              </div>
                              </div>
                              <!-- <div v-show="isEditting('password')" style="position:relative;inset-inline-end:20%">
                                <div class="d-flex">
                                <save-icon @click.native="saveBasicInfoField('password')"></save-icon>
                                <cancel-icon @click.native="cancelBasicInfoField()"></cancel-icon>
                              </div>
                              </div> -->
                            </div>
                            <div>
                            <span v-show="!matchedPassword" class="pl-1 pt-1 validationmessage">Passwords are not matching!!</span>
                          </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="key-div">{{$t('Email Id')}}</td>
                          <td class="value-div float-left m-0" style="width: 100% !important">
                            <div style="display: inline-flex;align-items:center" class="w-100">
                              <div class="w-100">
                                <div class="d-inline-flex">
                                  <span v-show="!isEditting('email')">{{userInfo.email}}</span>
                                  <div class="email-verification-status-main-wrapper">
                                    <svg v-if="userInfo.email_status == 'verified' && !isEditting('email') && userInfo.email" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green" class="bi bi-check-circle-fill emial-verified-icon" viewBox="0 0 16 16">
                                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                    </svg>
                                  </div>
                                  <edit-icon @click.native="editBasicInfoField('email')" v-show="!isEditting('email')" class="editIcon"></edit-icon>
                                </div>
                                <input type="email" v-model="postData.email"  placeholder="Enter email id" v-show="isEditting('email')" @input="validEmailCheck" class="bg-transparent border rounded text-light w-100 pl-2 comm-input-field-style"/>
                              </div>
                              <div v-show="isEditting('email')">
                                <div class="d-flex" style="margin-inline-start: 10px;">
                                  <save-icon @click.native="saveBasicInfoField('email')"></save-icon>
                                  <cancel-icon
                                   @click.native="cancelBasicInfoField()"
                                  ></cancel-icon>
                                </div>
                              </div>
                            </div>
                            <div v-if="userInfo.email && !isEditting('email')" style="margin-top: 10px;">
                              <div v-if="userInfo.email_status === 'unverified' || !userInfo.email_status">
                                <span style="color: #666666;"> {{$t('Unverified')}} - </span>
                                <button class="btn btn-outline-primary" @click="sendGetVerificationCodeRequest(postData.email)"> {{ $t("Verify Now") }}</button>
                              </div>  
                              <div v-else-if="( userInfo.email_status === 'expired' || (userInfo.email_status === 'pending' &&  remainingTime === 0))" style="display:inline-block">
                                <button class="btn btn-outline-primary" @click="sendGetVerificationCodeRequest(postData.email)"> {{ $t("Resend code") }}</button>
                                <span class="text-danger" style="width:100%;display:inline-block">{{$t('Verification code expired')}}</span>
                              </div>
                              <div v-else-if="userInfo.email_status === 'pending' && remainingTime>0" >
                                <input
                                class="comm-input-field-style"
                                id="verificationCode"
                                v-model.trim="emailVerificationCode"
                                inputmode="numeric"
                                type="text"
                                autocomplete="one-time-code"
                                maxlength="6"
                                :placeholder="$t('Code')"
                                aria-describedby="timerText helperText"
                                style="width: 108px; margin-right:10px; color:#fff"
                                @input="emailVerificationCode = emailVerificationCode.replace(/\D/g, '').slice(0, 6)"

                                />
                                <button id="verifyCodeBtn" class="btn btn-primary" type="button" @click="verifyCode()">
                                  {{$t('Verify Code')}}
                                </button>
                                <span class="timer" v-if="remainingTime">{{$t('Code valid for')}} {{ formatTime(remainingTime) }}</span>
                              
                                

                                <!-- <button id="resendBtn" class="secondary" type="button" onclick="sendCode()" style="display:none;">
                                  Resend
                                </button> -->
                              </div>
                            </div>
                            <div v-if="userInfo.email">
                              <span v-if="rowMessage" class="row-message">{{ rowMessage }}</span>
                              <span v-show='!validEmail' class="pl-1 pt-1 validationmessage">{{$t('Invalid email address')}}</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="key-div">{{$t('Contact Number')}}</td>
                          <td class="value-div float-left m-0" style="width: 100% !important">
                            <div style="display: inline-flex;align-items:center" class="w-100">
                              <div class="w-100">
                                <div class="d-inline-flex">
                                  <span v-show="!isEditting('number')">{{userInfo.contact_number}}</span>
                                  <edit-icon @click.native="editBasicInfoField('number')" v-show="!isEditting('number')" class="editIcon"></edit-icon>
                                </div>
                                <input
                                type="number"
                                min="0"
                                id= "contact_number_input"
                                @input="validContactNumberCheck"
                                v-model="postData.contact_number"
                                v-show="isEditting('number')"
                                placeholder="Enter contact number"
                                class="bg-transparent border rounded text-light w-100 pl-2 comm-input-field-style"
                                />
                              </div>
                              <div v-show="isEditting('number')">
                                <div class="d-flex" style="margin-inline-start: 10px;">
                                  <save-icon @click.native="saveBasicInfoField('contact_number')"></save-icon>
                                  <cancel-icon
                                    @click.native="cancelBasicInfoField()"
                                  ></cancel-icon>
                                </div>
                              </div>
                            </div>
                            <div>
                                <span v-show="!validNumber" class="p1-1 pt-1 validationmessage">{{$t('Invalid contact number')}}</span>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="getLoggedInUserInfo.user_type == 'Client' && isEnabled('Ticket')">
                          <td class="key-div">{{$t('Default CCs')}}</td>
                          <td class="value-div float-left m-0" style="width: 95%; !important">
                            <div style="display: inline-flex" class="w-100">
                              <div class="w-100">
                                <div class="d-inline-flex">
                                    <div v-if="Object.keys(userInfo).includes('default_assignees') && userInfo.default_assignees.length > 1" :key="cc">
                                      <span v-show="!isEditting('default_assignees')" style="width:100%;display:inle-block;word-break: break-word;">{{userInfo.default_assignees.join(",")}}</span>
                                    </div>
                                    <div v-else :key="cc">
                                      <span v-if="Object.keys(userInfo).includes('default_assignees')" v-show="!isEditting('default_assignees')" style="width:100%;display:inle-block;word-break: break-word;">{{userInfo.default_assignees[0]}}</span>
                                    </div>
                                  <edit-icon @click.native="editBasicInfoField('default_assignees')" v-show="!isEditting('default_assignees')" class="editIcon"></edit-icon>
                                </div>
                                <input
                                id= "default_CCs_input"
                                @input="validDefaultCCsCheck"
                                v-model="defaultAssigneeValue"
                                v-show="isEditting('default_assignees')"
                                class="bg-transparent border rounded text-light w-100 pl-2 comm-input-field-style"
                                />
                                <!-- postData.default_assignees -->
                              </div>
                              <div v-show="isEditting('default_assignees')" style="display:inline-flex;align-items:center">
                                <div class="d-flex" style="margin-inline-start: 10px;">
                                  <save-icon @click.native="saveBasicInfoField('default_assignees')"></save-icon>
                                  <cancel-icon
                                    @click.native="cancelBasicInfoField()"
                                  ></cancel-icon>
                                </div>
                              </div>
                            </div>
                            <div>
                                <span v-show="!validCCMailId" class="p1-1 pt-1 validationmessage">{{$t('Invalid Mail Ids')}}</span>
                            </div>
                          </td>
                        </tr>
                    </tbody>
                 </table>
  </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Utils from "../../components.utils.js";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import Constants from "../../components.constants.js";
// import Multiselect from "vue-multiselect";

export default {
  name: "UserPreferences",
  computed:{
    ...mapGetters("users",["getLoggedInUserInfo","getLoggedInUserId", "getLoggedInUserPrivilege"]),
  },
  components: {
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    // Multiselect
  },
    data() {
    return {
      showUserPref:true,
      userInfo: {},
      postData: {},
      password: '',
      imageType:null,
      currentPasswordFieldType: 'password',
      passwordFieldType: 'password',
      verifypasswordFieldType: 'password',
      validPassword:true,
      validEmail:true,
      validNumber:true,
      validCCMailId:true,
      matchedPassword:true,
      activeField: null,
      editingKey: null,
      verifiedPassword:null,
      emailRegex: new RegExp(/^([a-z0-9._%+-]+)@([a-z0-9.]+)\.([a-z]{2,3})(\.[a-z]{2,3})?$/),
      passwordRegex: new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/),
      // eslint-disable-next-line no-useless-escape
      contactNumber: new RegExp(/(^\+[\d]{2}[\d]{10})|(^[\d]{10}$)|(^[\d]{3}[\-]{1}[\d]{8}$)/),
      MAX_WIDTH: 320,
      MAX_HEIGHT: 180,
      MIME_TYPE: "image/jpeg",
      QUALITY: 0.7,
      uploadedImage:"",
      PROFILE_IMAGE_ALLOWED_WIDTH:128,
      defaultAssigneeValue : "",
      timer:null,
      // showVeriyCodeField:false,
      rowMessage:"",
      emailVerificationCode:"",
      remainingTime:null,
    };
  },
    methods:{
      uploadProfileImage(ev){
          this.imageType = "canvas";
          let file = ev.target.files[0]; // get the file
          // this.encodeImgtoBase64(file)
          let blobURL = URL.createObjectURL(file);
          this.drawImage(blobURL,false)
      }, 
      isEnabled(priv){
          return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
      },
      drawImage(blobURL,dontPost=true){
        this.imageType = "canvas";
        let img = new Image();
          img.src = blobURL;
          img.onerror = ()=> {
            URL.revokeObjectURL(this.src);
            // Handle the failure properly
            console.log("Cannot load image");
          };
          img.onload = ()=> {
            URL.revokeObjectURL(this.src);
            let wrh = img.naturalWidth / img.naturalHeight;
            let calculatedImageHeightAsPerAspectRatio = this.PROFILE_IMAGE_ALLOWED_WIDTH / wrh;
            let canvas = this.$refs.preferenceUploadCanvas;
            canvas.width = this.PROFILE_IMAGE_ALLOWED_WIDTH;
            canvas.height = calculatedImageHeightAsPerAspectRatio
            // let canvas = document.getElementById("canvas");
    /*         let newWidth = canvas.width;
            let newHeight = newWidth / wrh;
            if (newHeight > canvas.height) {
                newHeight = canvas.height;
                newWidth = newHeight * wrh;
            } */
            canvas.getContext("2d").drawImage(img, 0, 0, this.PROFILE_IMAGE_ALLOWED_WIDTH, calculatedImageHeightAsPerAspectRatio);

            console.log(canvas.toDataURL());

            // document.getElementById('image_tag').src = canvas.toDataURL();
            this.$nextTick(()=>{
              this.uploadedImage = canvas.toDataURL();
              this.$nextTick(() => {
                if(!dontPost)this.saveBasicInfoField('profile_image')
              })
            });

            // this.uploadedImage = canvas.toDataURL(); need to un-comment this line for posting
            
/*          let [newWidth, newHeight] = Utils.calculateSize(img, this.MAX_WIDTH, this.MAX_HEIGHT);
            let canvas = document.getElementById("canvas");
            canvas.width = newWidth;
            canvas.height = newHeight;
            let ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, newWidth, newHeight); */
          };
      }, 
      encodeImgtoBase64(img) {
        var reader = new FileReader();
        reader.onloadend = () => {
          this.uploadedImage = reader.result;
        }
        reader.readAsDataURL(img);
      },
      displayInfo(label, file) {
        const p = document.createElement('p');
        p.innerText = `${label} - ${this.readableBytes(file.size)}`;
        document.getElementById('root').append(p);
      },
      readableBytes(bytes) {
        const i = Math.floor(Math.log(bytes) / Math.log(1024)),
          sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
      },
      isComponentEnabled(compName){
        return Utils.isComponentEnabled(compName)
      },
      isPasswordEnforced(){
        return JSON.parse(Utils.getLocalStorageValue('enable_password_enforcement'))
      },
      validPasswordCheck(){
        if(this.isPasswordEnforced()){
        if(this.postData.password.length != 0 && this.passwordRegex.exec(this.postData.password) != null){
          this.validPassword = true;
          this.passwordVerificationCheck();
        }else{
          this.validPassword = false
        }
        }else if(this.postData.password.trim().length > 0){
          this.validPassword = true
          this.passwordVerificationCheck();
        }else{
          this.validPassword = false
        }
      },
      passwordVerificationCheck(){
        if(this.verifiedPassword == this.postData.password && this.verifiedPassword.length != 0){
          this.matchedPassword = true;
        }else{
          this.matchedPassword = false;
        }
      },
      validEmailCheck() {
        if (
          (this.postData.email.length != 0 &&
          this.emailRegex.exec(this.postData.email) != null) ||
          (typeof this.postData.email == "undefined" || this.postData.email.length <= 0)
        ) {
          this.validEmail = true;
        } else{
          this.validEmail = false;
        }
      },
      editBasicInfoField(keyName) {
        this.editingKey = keyName;
      },
      switchVisibilityCurrentPassword(){
        this.currentPasswordFieldType = this.currentPasswordFieldType === "password" ? "text" : "password";
      },
      switchVisibilityNewPassword() {
        this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
      },
      switchVisibilityVerifyPassword(){
        this.verifypasswordFieldType = this.verifypasswordFieldType === 'password' ? 'text' : 'password';
      },
      isEditting(keyName) {
        return keyName === this.editingKey;
      },
      cancelBasicInfoField() {
        this.editingKey = null;
        this.validPassword = true
        this.validEmail = true
        this.validNumber = true
        this.validCCMailId = true
        this.matchedPassword =true
      },
      removeProfileImage(){
        if(confirm('Are you sure you want to remove profile image?')){
          this.uploadedImage = "";
          this.$nextTick(() => {
            this.saveBasicInfoField('profile_image')
          })
        }
      },
      saveBasicInfoField(field) {
        let payload = {}
        if(field == "username" &&
          (typeof this.postData.username == "undefined" ||
          this.postData.username.trim().length <= 0)){
          alert("Please add valid display name. ")
          return
        }
        if(field == "password"){
          if(typeof this.postData.old_password == "undefined" || this.postData.old_password.length <= 0){
            alert("Please add valid current passsword. ");
            document.getElementById("oldPassword").focus();
            return
          }
          if(typeof this.postData.password == "undefined" || this.postData.password.length <= 0 ||
            !this.validPassword){
            alert("Please add valid new password.")
            document.getElementById("password").focus();
            return
          }
          if(!this.matchedPassword){
            alert("Passwords are not matching.")
            document.getElementById("verifyPassword").focus();
            return
          }
          payload["old_password"] = this.postData["old_password"]
        }
        if(!this.validEmail){
          alert("Please add a valid email address. ")
          document.getElementById("verifyEmail").focus();
          return
        }
        if(!this.validCCMailId){
          alert("Please add valid email addresses. ")
          document.getElementById("default_CCs_input").focus();
          return
        }
        if(field == "profile_image"){
          payload.profile_image = this.uploadedImage;
        }else if (field == "default_assignees"){
          if(this.defaultAssigneeValue != ""){
            payload[field] = this.defaultAssigneeValue.split(",");
          }else{
            payload[field] = [];
          }  
        }else{
          payload[field] = this.postData[field]
        }
        payload.user_preferences = true;
        payload.params = { user_id: this.getLoggedInUserId};
        this.updateLoggedInUserPreferences(payload).then((data)=>{
          if(data.statusCode == 200){
            this.userInfo[field] = this.postData[field];
            this.$toast.success(data.message)
            this.editingKey = null;
            this.validPassword = true;
            this.validEmail = true;
            this.validNumber = true;
            this.validCCMailId = true
            delete this.postData["password"]
            this.verifiedPassword = "";
            if(!this.uploadedImage || this.uploadedImage.trim().length<0){
              this.imageType = null;
            }
          }else{
            this.$toast.error(data.error ||
              data.Error ||
              data.message ||
              data.Message ||  this.$t("Failed to verify email"));
            return
          }
        })
      },
      validContactNumberCheck() {
        if (
          typeof(this.postData.contact_number) != "undefined" && 
          this.postData.contact_number.trim().length >= 10 
        ) {
          this.validNumber = true;
        } else {
          this.validNumber = false;
        }
      },
      validDefaultCCsCheck() {
        this.validCCMailId = true
        if(this.defaultAssigneeValue != ""){
          let mailIds = this.defaultAssigneeValue.replaceAll(" ", "").split(",") 
          console.log("DEFAULT ASSIGNEES ARE", this.postData.default_assignees, mailIds, mailIds.length)
          if (mailIds.length != 0) {
            if (mailIds.length == 1){
              if (this.emailRegex.exec(mailIds[0]) == null) {
                return this.validCCMailId = false;
              }
            }else if(mailIds.length > 1){
              for(let i = 0; i < mailIds.length ; i++){
                if (this.emailRegex.exec(mailIds[i]) == null) {
                  return this.validCCMailId = false;
                }
              }
            }
          }
        }  
      },
      close() {
          this.$emit('close');
      },

      //********* user email verification ******************
        isValidEmail(email) {
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return regex.test(email);
        },

        startTimer() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          if (this.remainingTime <= 0) {
            return;
          }
          this.timer = setInterval(() => {
            if (this.remainingTime > 0) {
              this.remainingTime--;
            } 

            if (this.remainingTime <= 0) {
              clearInterval(this.timer);
              this.timer = null;

              this.remainingTime = 0;
              // this.showVeriyCodeField = false;
              // this.userInfo.email_status = "expired";
              this.$set(this.userInfo, "email_status", "expired");

              this.setCurrentUserinfo(this.userInfo);
              Utils.setLocalStorageValue("userInfo", JSON.stringify(this.userInfo));
            }
            
          }, 1000);
        },


        sendGetVerificationCodeRequest(emailId){
          if (!this.isValidEmail(emailId)) {
            this.rowMessage = this.$t("Please enter a valid email ID.");
            return;
          }

          let payload = {
            // params:{
            // email_id: emailId,
            // my_email: true
            // }
          };

          this.userGetVerificationCode(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              this.$toast.success(data.message ? data.message : this.$t("Verification code sent"));

              this.$set(this.userInfo, "email_status", "pending");
              this.remainingTime = 900;
              this.emailVerificationCode = "";
              this.rowMessage = "";
              // this.showVeriyCodeField = true;

              this.setCurrentUserinfo({ ...this.userInfo });
              Utils.setLocalStorageValue("userInfo", JSON.stringify(this.userInfo));

              this.$nextTick(() => {
                this.startTimer();
              });
              // this.startTimer();

            }else{
              this.$toast.error(
                data.error ||
                data.Error ||
                data.message ||
                data.Message ||
                this.$t("Failed to send verification code")
              );
            }
          });    
        },

        formatTime(seconds) {
          const minutes = Math.floor(seconds / 60);
          const secs = seconds % 60;

          return (
            String(minutes).padStart(2, "0") +
            ":" +
            String(secs).padStart(2, "0")
          );
        },

        verifyCode() {
          if(!this.emailVerificationCode.length){
            alert("Please enter the verification code.")
            return;
          }
          let payload = {
            userId:this.getLoggedInUserId,
            params:{
              // my_email:true,
              context: "verify_email",
              // email_id: this.postData.email,
              pin: parseInt(this.emailVerificationCode),
            }
          };
          this.verifyLoggedInUserEmailId(payload).then((data)=>{
            if(Utils.isAcceptedStatusCode(data.statusCode)){
              this.$toast.success(data.message ? data.message : this.$t("Email verified successfully"));
              this.userInfo["email_status"] = "verified";
              this.setCurrentUserinfo(this.userInfo);
              Utils.setLocalStorageValue("userInfo", JSON.stringify(this.userInfo))
              this.remainingTime = null;
              // this.showVeriyCodeField = false;
              this.emailVerificationCode = "";

              if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
              }

            }else{
              this.$toast.error(data.error ||
              data.Error ||
              data.message ||
              data.Message ||  this.$t("Failed to verify email"));
            }
          })
        },

        getEmailVerifiedStatus(){
          let payload = {};
          this.getLoggedInUSerEmailVerifyStatus(payload).then((data)=>{
            if(Utils.isAcceptedStatusCode(data.statusCode)){
              this.userInfo.email_status = data.status;
              this.setCurrentUserinfo(this.userInfo);
              Utils.setLocalStorageValue("userInfo", JSON.stringify(this.userInfo));
              if('verified' != this.userInfo.email_status && 'expired' != this.userInfo.email_status){
                if(data.minutes >=0 || data.seconds >=0){
                  // this.remainingTime = (data.minutes * 60) + data.seconds;
                  const minutes = Number(data.minutes) || 0;
                  const seconds = Number(data.seconds) || 0;

                  this.remainingTime = minutes * 60 + seconds;
                  if(this.remainingTime > 0){
                    // this.showVeriyCodeField = true;
                    this.startTimer();
                  }else{
                    // this.showVeriyCodeField = false;
                  }  
                }
              }else if (data.status === "expired") {
                this.remainingTime = null;
                // this.showVeriyCodeField = false;
              } else if (data.status === "verified") {
                this.remainingTime = null;
                // this.showVeriyCodeField = false;
              }
            }else{
              this.$toast.error(data.error ||
                  data.Error ||
                  data.message ||
                  data.Message || this.$t("Failed to get email verification status"));
            }
          })
        },

      //**************************** */
      updateUserPreference(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message._id == this.getLoggedInUserId){
        let userNotiticationData = notification.message;
        this.userInfo = userNotiticationData;
        this.postData.username =  userNotiticationData.username;
        this.postData.email =  userNotiticationData.email;
        this.postData.contact_number =  userNotiticationData.contact_number;
        
        this.defaultAssigneeValue = userNotiticationData.default_assignees.join(",");
        this.postData.default_assignees = userNotiticationData.default_assignees;
        }

      },
      ...mapActions("users", ["updateExistingUser","updateLoggedInUserPreferences", "userGetVerificationCode","verifyLoggedInUserEmailId", "getLoggedInUSerEmailVerifyStatus"]),
      ...mapMutations("users", ["setCurrentUserinfo"]),
      ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    },
    created(){
      Object.assign(this.userInfo, this.getLoggedInUserInfo);
      this.postData = this.getLoggedInUserInfo
      if(Object.keys(this.postData).includes('password')){
        delete this.postData['password']
      }

      if(this.postData.default_assignees && this.postData.default_assignees.length>0){
        this.defaultAssigneeValue = this.postData.default_assignees.join(",")
      }
      if(this.postData.profile_image != undefined && this.postData.profile_image.length > 0){
          // this.imageType = "image";
          this.drawImage(this.postData.profile_image,true)
      }

      if(this.postData.email_status && this.postData.email_status != 'verified' && this.postData.email_status != 'unverified'){
        this.getEmailVerifiedStatus();
      }  
      //***************hardcode for now until get backend support************** */
      this.selectedTimeZoneValue="Asia/Kolkata",
      //*************************************** */
      
      this.addWSEventListener({eventname:Constants.userUpdatedNotification, callback:this.updateUserPreference,  parent:"UserConfigInPreferences"});
    },
    beforeDestroy(){
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.removeWSEventListener({eventname:Constants.userUpdatedNotification, callback:this.updateUserPreference,  parent:"UserConfigInPreferences"});
    }
}
</script>


<style scoped lang="scss">
$header-background: #1a1a1a;
// $border-color: 1px solid #3a3a3a;
$background: #121212;
// $bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
// $dull-text-color: #757575;
$options-text-color: #9c9c9c;
// $text-color: #bbb;
$table-row-border: none;
// $active-blue : #007bff;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
// $danger-color:#dc3545!important;

$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$button-height:38px;
$tags-border-color:#363636;
$metadata-border-color-on-hover: #5a5a5a;
$secondary-border-color: 1px solid #2b2b2b;
$active-green-color:#28a745;
$svg-color:#666;
$learn-about-text-color-hover:#b7b327;
$active-green-icon-color: #00ff3a;
$learn-about-text-color:#9a9620;
$readOnly-bg-color: #1e2326 !important;


#contact_number_input::-webkit-outer-spin-button,
#contact_number_input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.modal-dialog {
    max-width:100%;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $body-bg-color !important;
    border: $modal-border;
    .modal-body{
      background: $modal-background;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}
.btn{
    font-size:14px !important;
    height:100%;
}
.users-basic-info-table {
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: $table-row-border !important;
      border-bottom: $table-row-border !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: $table-row-border !important;
    }
  }
}
.validationmessage{
  color:$danger-color;
  font-size: 11px;
}

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border: none !important;
    background: $header-background;
    .modal-title{
      color:$header-color;
    }
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.sidebar{
    background: $background;
    color: $options-text-color;
}
.sidebar:hover{
    color: $text-color;
}
table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}
.editIcon {
  margin-inline-start: 9px;
}

.comm-input-field-style{
    background: $primary-background!important;
    // width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
    border-radius: 6px !important;
}

input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}


.profile-image-upload-wrapper{
  padding:30px;
  .profile-image-display{
      height: auto;
      display:flex;
      justify-content:center;
      border: 1px solid #3a3a3a;
      border-radius: 10px;
      .canvas{
            height: 100%;
            width: 100%;
            border-radius: 5px;
      }
  }
  .upload-profile-image-button{
      padding: 15px 0px;
      margin: 0 auto;
      display: inline-block;
      .btn-wrapper{
        margin-bottom: 8px;
        width: 170px;
        button{
          width:96%;
        }
      }
  }
}
.profile-image:hover{
  .profile-image-change{
    color: #fff !important;
    background-color: #007bff;
    border-color: #007bff;
    border-radius:0.25rem;
  }
}

.email-verification-status-main-wrapper{
  .emial-verified-icon{
    margin-left:10px;
  }
}

.timer{
  display: inline-block;
    width: 100%;
    font-size: 12px;
    margin-top: 7px;
    color:$dull-text-color;
    padding-inline-start: 4px;
}
::v-deep{

  .multiselect{
                width:100%;
                margin: 3px 0px;
                // display: flex; this is commented bcz if dispalay : flex given then dropdown will be overlap on the feild
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .tags-style{
            margin:5px;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
            width: 100%;
            height: 44px !important;
            padding: 5px 40px 0 8px!important;
              .selected-tags-style{
                  margin : 0px !important;
              }
            
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
            color:$dull-text-color !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
        }

}  
</style>